/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { NormalizedPatient } from '../models/patient';
import { NormalizedMission } from '../models/operational';

/* eslint-disable @typescript-eslint/no-explicit-any */
export function findPatientDataDiff(diff: [string, any][], patientKey: keyof NormalizedPatient) {
  return diff.find((diffEntry) => diffEntry[0] === patientKey);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function hasPatientDataDiff(diff: [string, any][], patientKey: keyof NormalizedPatient) {
  return diff.some((diffEntry) => diffEntry[0] === patientKey);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function hasAnyPatientDataDiff(diff: [string, any][], patientKeys: (keyof NormalizedPatient)[]) {
  return patientKeys.some((patientKey) => hasPatientDataDiff(diff, patientKey));
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function hasMissionDataDiff(diff: [string, any][], missionKey: keyof NormalizedMission) {
  return diff.some((diffEntry) => diffEntry[0] === missionKey);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function hasAnyMissionDataDiff(diff: [string, any][], missionKeys: (keyof NormalizedMission)[]) {
  return missionKeys.some((missionKey) => hasMissionDataDiff(diff, missionKey));
}
